import { Design, DraftConfigurationRestrict } from '@/types';

export const getDraftConfigurationRestrictForDesign = ({
  restrictions: { allowRotate, allowScale },
}: Design): DraftConfigurationRestrict | undefined => {
  if (allowRotate && allowScale) {
    return;
  }

  return {
    ...(allowRotate ? {} : { rotate: true }),
    ...(allowScale ? {} : { scale: true }),
  };
};
